(ns net.kestec.mhda-pilgrimage.auth.auth-events
  (:require
    [net.kestec.mhda-pilgrimage.route :as route]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))



(rf/reg-event-fx
  ::store-me
  (fn [{db :db} [_ me]]
    {:db       (merge db {::db/me me})
     :dispatch [::db/load-all]}))

(rf/reg-event-fx
  ::auth-error
  (fn [{db :db} [_ error]]
    (println "auth-error" (:parse-error error))
    (when (= (get-in error [:parse-error :status] 401))
      {:dispatch [::route/push ::route/public.landing]})))

(rf/reg-event-fx
  ::load-me
  (fn [_ _]
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/auth/me")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::store-me]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::store-me-and
  (fn [{db :db} [_ and-event me]]
    (println "store-me-and +"  me and-event)
    (if-not (:is-valid me)
      {:dispatch [::route/push ::route/public.landing]}
      {:db       (merge db {::db/me me})
       :dispatch [and-event]})))

(rf/reg-event-fx
  ::load-me-and
  (fn [_ [_ and-event]]
    (println "load-me-and +" and-event)
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/auth/me")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::store-me-and and-event]
                   :on-failure      [::auth-error]}]}))

